/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 保存订单问卷调查结果
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  req: order.OrderTicketQuestionnaireReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/orders/questionaire`,
    data: req,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
